import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './SupplierUserCard.module.scss';
import SlideCard from '../../common/SlideCard';
import Button from '../../common/Button';
import SimpleCheckbox from '../../common/SimpleCheckbox';
import MultipleSelect from '../../common/MultipleSelect';
import isEqual from 'lodash/isEqual';
import { fullName } from '../../../utils/textHelper';

function SupplierUserCard(props) {
  const { data, isAuthorized } = props;
  const { user, email } = data;

  const originalIsAdmin = useRef(props.data.is_admin);
  const originalRetailerIds = useRef(props.data.retailer_ids);

  const [isAdmin, setIsAdmin] = useState(data.is_admin);
  const [retailerIds, setRetailerIds] = useState(data.retailer_ids.map((id) => +id));

  const onSubmit = () => {
    const userData = {
      is_admin: isAdmin,
      email,
    };

    if (!isAdmin) {
      userData.retailer_ids = retailerIds;
    }

    props.updateUserRetailers(email, userData);
    originalIsAdmin.current = isAdmin;
    originalRetailerIds.current = retailerIds;
  };

  const permissionsChanged = () => {
    if (isAdmin) {
      return originalIsAdmin.current !== isAdmin;
    } else {
      return retailerIds.length === 0 || !isEqual(originalRetailerIds.current, retailerIds);
    }
  };

  const buttonIsDisabled = () => {
    if (!permissionsChanged()) {
      return true;
    }

    return !isAdmin && retailerIds.length === 0;
  };

  const deleteUser = () => {
    if (user) {
      props.openConfirmModal(user, 'delete');
    } else {
      props.deleteUserInvitation(email);
    }
  };
  const showUnblockButton = !!(isAuthorized && user?.blocked_date);
  const title = user ? fullName(user) : `${email} (Invited)`;
  const titleButton = props.isCurrentUser ? (
    <span>Current User</span>
  ) : (
    <>
      {showUnblockButton && (
        <button className={styles.unblock} onClick={() => props.openConfirmModal(user, 'unblock')}>
          Unblock
        </button>
      )}
      <button className={styles.delete} onClick={deleteUser}>
        {user ? 'Remove' : 'Uninvite'}
      </button>
    </>
  );

  return (
    <SlideCard title={title} right={titleButton} active={false} toggle>
      <div className={styles.info}>
        <div>
          <dl>
            {user ? (
              <>
                <dt>First name:</dt>
                <dd>{user.first_name}</dd>

                <dt>Last name:</dt>
                <dd>{user.last_name}</dd>
              </>
            ) : (
              ''
            )}

            {user && user.phone ? (
              <>
                <dt>Phone number:</dt>
                <dd>{user.phone}</dd>
              </>
            ) : (
              ''
            )}

            <dt>E-mail:</dt>
            <dd>
              <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                {email}
              </a>
            </dd>
          </dl>
        </div>
        <div className={styles.permissions}>
          <dl>
            <dt>
              <SimpleCheckbox value={1} label={'Is Admin?'} checked={isAdmin} onChange={setIsAdmin} />
            </dt>
          </dl>

          {!isAdmin && (
            <MultipleSelect options={props.allRetailers} selected={retailerIds} onChange={setRetailerIds} sort />
          )}

          <div className={styles.commit}>
            <Button
              text={isAdmin ? 'Update Permissions' : 'Update Retailers'}
              onClick={onSubmit}
              disabled={buttonIsDisabled()}
            />
          </div>
        </div>
      </div>
    </SlideCard>
  );
}

export default SupplierUserCard;

SupplierUserCard.defaultProps = {
  isCurrentUser: false,
};

SupplierUserCard.propTypes = {
  data: PropTypes.object.isRequired,
  updateUserRetailers: PropTypes.func.isRequired,
  openConfirmModal: PropTypes.func.isRequired,
  deleteUserInvitation: PropTypes.func.isRequired,
  allRetailers: PropTypes.array,
  isCurrentUser: PropTypes.bool,
};
